import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=bb6c13d8&"
import script from "./automatic.vue?vue&type=script&lang=ts&"
export * from "./automatic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports